import './AfterGrade.scss'

import * as lottie_posgrade from '../../lotties/AfterGrade/posgrade.json'

import AddressBookComp from '../../components/AddressBook/AddressBook'
import Desplegable from '../../components/Desplegable/Desplegable'
import DidYouKnow from '../../components/DidYouKnow/DidYouKnow'
import ExternalLink from '../../components/ExternalLink/ExternalLink'
import ListItem from '../../components/ListItem/ListItem'
import Lottie from 'react-lottie'
import { ModalContainer } from '../../components/Containers/ModalContainer'
import { SectionContainer } from '../../components/Containers/SectionContainer'
import { animated } from 'react-spring'
import { contacts } from '../../data'

const AfterGrade = ({ color = 'yellow', secondary = 'dark-blue', scrollRight, modalHandling, closeModal, section, parallax, setLock }) => {
  // Lotties

  // https://assets7.lottiefiles.com/private_files/lf30_Pc7YxP.json
  const lottiePosgrade = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_posgrade.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )

  // Desplegables area
  const threeMins = (
    <div className="desplegable-container three-mins">
      <p>
        Es una serie de <span className="bold">micro-entrevistas en vídeo</span> en las que <span className="bold">titulados UAM</span> nos cuentan cómo han
        llegado a dónde están después de terminar los estudios que tú acabas de comenzar. Sus <span className="bold">consejos</span> pueden ser una gran ayuda
        durante tus años de estudiante.
      </p>
      <div className="video-container">
        <iframe
          title="Micro Entrevistas"
          width="100%"
          height="200"
          src="https://www.youtube.com/embed/?listType=playlist&list=PLGvERyy5OJeaR1wmrI44i4SCeXb2MofRa"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  )

  // Modals area
  const posgrado = (
    <ModalContainer secondary={secondary} color={color} title="Estudios de máster" onClick={() => closeModal()}>
      {lottiePosgrade}
      <p>
        La UAM oferta más de <b>80 Másteres oficiales</b> entre los que, a buen seguro, podrás encontrar el que te aportará la formación de calidad que potencie
        e impulse tu perfil.
      </p>
      <p>
        Todos ellos están diseñados para sacar el máximo partido a los estudios de Grado, ofreciendo capacidades y un nivel de especialización que sin duda
        representarán un gran valor añadido en tu trayectoria. De hecho, <b>existen másteres recomendados desde cada Grado o Doble Grado UAM</b> que puedes
        consultar en la ficha web de los mismos.
      </p>
      <DidYouKnow color={color}>
        <p>
          Los máster Erasmus Mundus son programas de estudio <b>internacionales</b> impartidos conjuntamente por un consorcio internacional de instituciones de
          educación superior y cuentan con un <b>gran prestigio</b>.
        </p>
      </DidYouKnow>
      <p>
        Los másteres oficiales, por lo general, incluyen distintas <b>especialidades o itinerarios</b> y pueden tener un enfoque bien hacia la{' '}
        <b>capacitación profesional</b> o hacia la <b>formación investigadora</b>. Estas son opciones que tendrás que elegir de acuerdo a tus intereses.
      </p>
      <ExternalLink
        url="https://uam.es/CentroEstudiosPosgrado/Home/1446755956185.htm?language=es_ES"
        text="Más información"
        color={secondary}
        secondary={color}
      />
      <AddressBookComp color={color} data={contacts['posgrado']} />
    </ModalContainer>
  )

  const own_titles = (
    <ModalContainer secondary={secondary} color={color} title="Títulos propios" onClick={() => closeModal()}>
      <p>
        Los títulos o estudios propios son programas diseñados por la Universidad Autónoma de Madrid en colaboración con profesionales de alto prestigio, para
        dar respuesta a necesidades laborales y sociales. Los estudios propios <b>no dan acceso a programas de doctorado</b>, pero ofrecen una formación muy{' '}
        <b>valorada y avalada por el prestigio y la calidad UAM</b>.
      </p>
      <DidYouKnow color={color} title="!">
        <p>
          Recuerda que el Centro de Formación Continua UAM también ofrece <b>cursos de corta duración</b> que puedes cursar en cualquier momento de la vida.
        </p>
      </DidYouKnow>
    </ModalContainer>
  )

  const doctorate = (
    <ModalContainer secondary={secondary} color={color} title="Doctorado" onClick={() => closeModal()}>
      <p>
        La Escuela de <b>Doctorado UAM</b> es un centro clave en la estrategia de la universidad para impulsar la formación de investigadores.
      </p>
      <p>
        Desde su creación, la Autónoma ha venido desarrollando una <b>actividad investigadora</b> de muy alta calidad, que la ha convertido en una
        <b>universidad de referencia internacional</b> con una significativa relevancia en los rankings más prestigiosos.
      </p>
      <p>
        La oferta académica agrupa <b>36 programas de doctorado</b> en las áreas de Artes y Humanidades, Ciencias, Ciencias de la Salud, Ciencias Sociales y
        Jurídicas e Ingeniería.
      </p>
      <DidYouKnow color={color}>
        <p>
          El Programa{' '}
          <b>
            <i>Aula Abierta</i>
          </b>{' '}
          te permite cursar de manera independiente <b>casi cualquier materia</b> impartida en titulaciones oficiales de la Universidad. Esta alternativa te
          dará la posibilidad de <b>profundizar en áreas específicas</b> del conocimiento y de mantener el desarrollo formativo en cualquier momento de la vida.
          Además, al completar asignaturas en el marco de este programa, podrás obtener un <b>certificado acreditativo</b>.
        </p>
      </DidYouKnow>
      <AddressBookComp color={color} data={contacts['doctorado']} />
    </ModalContainer>
  )

  const alumniuam = (
    <ModalContainer secondary={secondary} color={color} title="Alumniuam" onClick={() => closeModal()}>
      <p>
        ... y cuando finalices tus estudios en la UAM podrás formar parte de AlumniUAM, un{' '}
        <span className="bold">programa para todas las personas tituladas en la Autónoma</span> que ofrece interesantes{' '}
        <span className="bold">beneficios y oportunidades:</span>{' '}
      </p>

      <div className="kite-list-items">
        <ListItem color={color} kiteColor={secondary}>
          <p>Te pondrá en contacto con otros profesionales</p>
        </ListItem>
        <ListItem color={color} kiteColor={secondary}>
          <p>Podrás participar en actividades exclusivas</p>
        </ListItem>
        <ListItem color={color} kiteColor={secondary}>
          <p>Nos permitirá mantener una relación continuada</p>
        </ListItem>
      </div>

      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="3 min con...">
          {threeMins}
        </Desplegable>
      </div>
      <AddressBookComp color={color} data={contacts['alumniuam']} />
    </ModalContainer>
  )

  const items = [
    { key: 'posgrado', content: posgrado, title: 'Estudios de máster' },
    { key: 'own_titles', content: own_titles, title: 'Títulos propios' },
    { key: 'doctorate', content: doctorate, title: 'Doctorado' },
    { key: 'alumniuam', content: alumniuam, title: 'Alumniuam' }
  ]

  const Splash = (
    <>
      <div className="logo-back">
        <img src="/splash/svg/AfterGrade_logo_back.svg" alt="" />
      </div>
      <animated.div className="logo-main" style={{ transform: parallax.logo_main(section) }}>
        <img src="/splash/svg/AfterGrade_logo_main.svg" className="illustration" alt="" />
        <img src="/splash/png/AfterGrade.png" className="image" alt="" />
      </animated.div>
    </>
  )

  return (
    <SectionContainer
      // Section
      className={'AfterGrade'}
      title={'Más allá del grado'}
      // General
      color={color}
      secondary={secondary}
      items={items}
      setLock={setLock}
      section={section}
      // Mobile
      handleMobileModal={modalHandling}
      scrollRight={scrollRight}
    >
      {Splash}
    </SectionContainer>
  )
}

export default AfterGrade
